import { render, staticRenderFns } from "./OffertaSlider.vue?vue&type=template&id=110f15e6"
import script from "./OffertaSlider.vue?vue&type=script&lang=js"
export * from "./OffertaSlider.vue?vue&type=script&lang=js"
import style0 from "./OffertaSlider.vue?vue&type=style&index=0&id=110f15e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports